module.exports = __webpack_public_path__ + "img/side-btn-blue.5ee35820.svg";